<template>
  <!--prominent izbacio iz vtoolbara ... -->
  <v-toolbar id="core-toolbar"
             flat
             color="algebra-back-black"
             class="py-3">

    
      <div class="v-toolbar-title ">
        <!--<v-spacer />-->
        <v-toolbar-title class="tertiary--text font-weight-light " style="color:white !important">
          <v-btn v-if="responsive || !responsive"
                 class=" v-btn--simple"
                 dark
                 icon
                 @click.stop="onClickBtn">
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
          <span class="title font-weight-light mb-2">
            <!--{{ title }}-->
          </span>
        </v-toolbar-title>
      </div>

      <v-layout row>


        <v-flex py-0 xs-3 offset-0 align-center>
          <v-img :src="algebraLogo"
                 :width="logoWidth"
                 :height="logoHeight"
                 class="mt-2"
                 contain />
        </v-flex>
        <v-flex xs-3 class="text-left">
          <h3 class="white--text algebra-font"> POLAZNIČKI PORTAL</h3>
        </v-flex>
        <v-toolbar-items>
          <v-flex align-center
                  layout
                  py-2>

            <a href="#" onclick="return false" @click="logout" :title="$t('security.btnSignOut')">
              <span class="white--text">{{$t('security.btnSignOut')}}</span>
              <v-icon color="purple lighten-5">mdi-account</v-icon>
            </a>
          </v-flex>
        </v-toolbar-items>
      </v-layout>
  </v-toolbar>
</template>

<script>

  import { mapMutations, mapActions } from 'vuex'

  export default {
    computed: {

    },
    data: () => ({
      algebraLogo: '/assets/images/logos/header-img1.png',
      logoHeight: 40,
      logoWidth: this.logoHeight * 5.42,
      notifications: [
        'Mike, John responded to your email',
        'You have 5 new tasks',
        'You\'re now a friend with Andrew',
        'Another Notification',
        'Another One'
      ],
      title: null,
      responsive: false,
      responsiveInput: false,
      algebra_logo: '/assets/images/logos/AlgebraLogo.png'
    }),

    watch: {
      '$route'(val) {
        this.title = this.$t(val.name)
      }
    },

    mounted() {
      this.onResponsiveInverted()
      window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResponsiveInverted)
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer', 'SET_LOGIN_MODAL']),
      ...mapActions('app', ['removeToken']),
      onClickBtn() {
        this.setDrawer(!this.$store.state.app.drawer)
      },
      logout() {
        this.removeToken();
        this.SET_LOGIN_MODAL(true);
      },

      onResponsiveInverted() {
        if (window.innerWidth < 991) {
          this.responsive = true
          this.responsiveInput = false
        } else {
          this.responsive = false
          this.responsiveInput = true
        }
      }

    },





  }
</script>

<style scoped>
  #core-toolbar a {
    text-decoration: none;
  }

  .algebra-font {
    font-family: stolzl-thin !important;
    font-weight: bold !important;
  }

  .header-div {
    font-size: 1.6em;
    font-weight: 100 !important;
    font-family: Arial
  }

  .default {
    color: white !important;
  }
</style>




// WEBPACK FOOTER //
// VueSrc/Common/Components/materialcomponents/components/core/Toolbar.vue